/**
 * @ngdoc component
 * @name home.component:homeManager
 *
 * @description
 
    #caso http://www.massimodutti.com', 

    - Si hemos entrado previamente ( tenemos localStorage con LAST_STORE) 
        - Si tenemos hemos seleccionado la sección previamente  ( tenemos localStorage con SECTION) 
            - Redirige a la home
        - Si no tenemos seleccionada la sección
            - Muestra WorldWide sin botón de GO
    - Si Entramos por primera vez: 
        - Muestra WorldWide y muestra el botón de Go
        - Si hacemos click en sección: 
            - Nos resalta el apartado de botón de GO
        
    #caso http://www.massimodutti.com/{lang}', 

    Caso normal

    - aterrizamos en  http://www.massimodutti.com/{lang}/session-expired

    - Url con parametro hash http://www.massimodutti.com/{lang}/?hash=xxxx

    - Url con parametro newsletterConfirm = ALTA http://www.massimodutti.com/{lang}/?newsletterConfirm=alta

    - Url con parametro newsletterConfirm = BAJA http://www.massimodutti.com/{lang}/?newsletterConfirm=baja

    - Url con parametro showNewsletterConfirm http://www.massimodutti.com/{lang}/?showNewsletterConfirm=1
*/
(function () {
    'use strict';

    var homeManagerCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'home-manager.component.html',
        controller: homeManagerCtrl
    };

    angular.module('itxApp.home').component('homeManager', homeManagerCmp);

    homeManagerCmp.$inject = [
        '$http',
        '$scope',
        'homeManagerSvc',
        'homeRedirectSvc',
        'ItxConfigurationSvc',
        '$timeout',
        'CountryService'
    ];

    function homeManagerCtrl(
        $http,
        $scope,
        homeManagerSvc,
        homeRedirectSvc,
        ItxConfigurationSvc,
        $timeout,
        CountryService
    ) {
        var _this = this;

        _this.$onInit = function () {
            //Checkeamos si la url tiene parametros para redirigir a otra página de la web
            //Se utiliza para páginas como paper o páginas externas que linkan a producto
            //La función misma gestiona el redirect.
            if (homeRedirectSvc.checkIsRedirectUrl()) {
                return;
            }

            var lastStoreJson = homeManagerSvc.getLastStore();

            if (window.location.search.indexOf('select-store=true') > -1) {
                _this.homeStatus = 'WORLDWIDE';
            } else {
                lastStoreJson = homeManagerSvc.getLastStore(true);
                //Estamos en la worldWide pero tenemos lastStoreID
                //Se comenta esta logica para forzar que no redirija
                if (
                    lastStoreJson &&
                    homeManagerSvc.validHomeParams(lastStoreJson.storeId, lastStoreJson.langId)
                ) {
                    //CASO redirección para CHINA...
                    if (homeRedirectSvc.redirectForChina(lastStoreJson.storeId)) {
                        return;
                    }

                    lastStoreJson.id = lastStoreJson.storeId;
                    var storeObj = {
                        store: lastStoreJson,
                        lang: { id: lastStoreJson.langId }
                    };
                    const section = inditex.getLocalStorage('LAST_SECTION');
                    // homeManagerSvc.updateVariablesFromSelectedStore(storeObj.store.id, storeObj.lang.id);
                    _this.navigate(storeObj.store, storeObj.lang, section);
                }
                //No hay lastStore..
                else {
                    //Mostramos worldwide
                    _this.homeStatus = 'WORLDWIDE';
                }
            }

            inditex.onReady(function () {

                if (inditex.iStoreListJSON) {
                    _this.storeList = inditex.iStoreListJSON.stores;
                    $timeout();
                } else {
                    homeManagerSvc.updateWorldWideInfo().then(function () {
                        _this.storeList = inditex.iStoreListJSON.stores;
                        $timeout();
                    });
                }
            });
        };
 
        _this.navigate = function (store, lang, section) {
            _this.tmpLastStore = { store: store, lang: lang };

            if (!homeManagerSvc.validHomeParams(store.id, lang.id)) {
                return false;
            }
            if (homeRedirectSvc.checkIfPendingRedirect()) {
                homeRedirectSvc.redirectPending(store, lang); //Redirigimos por /tener pendiente.
                return;
            }

            //CASO CHINA...
            if (homeRedirectSvc.redirectForChina(store.id, lang.id, section)) {
                return;
            }
            _this.store = store;

            inditex.setLocalStorage('LAST_SECTION', section);
            //hacemos la llamada de inditex como si cargaramos la home

            var isoCode;

            if (store.countryCode) {
                if (CountryService.isWWCountryId(store.id)) {
                    inditex.setLocalStorage('COUNTRY_ISO', store.countryCode);
                    //isoCode = store.countryCode;
                } else {
                    // Remove ISO Code if its not WW
                    inditex.removeLocalStorage('COUNTRY_ISO');
                }
            }
            //CAMBIOS NUEVOS
            var path = inditex.encodeUrl({
                action: 'ItxHomePage',
                params: {
                    storeId: store.id,
                    langId: lang.id
                }
            });

            if (section === 'MEN') {
                path += 'home-men.html';
            }

            document.location.href = path.toLowerCase();
        };

        _this.selectStore = function () {
            history.replaceState({}, null, '/');
            homeManagerSvc.updateWorldWideInfo().then(function () {
                homeManagerSvc.setWorldWideVariables();

                _this.storeList = inditex.iStoreListJSON.stores;
                _this.homeStatus = 'WORLDWIDE';
            });
        };
    }
})();
